// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import Container from "../Container"
import Heading from "../Heading"
import SwiperSlider from "../SwiperSlider"
import { classNames } from "../../utils/helpers"
import { serializers } from "../Serializers"
import { PortableText } from "@portabletext/react"

const SectionAwards = ({ section }: any) => {
  const { listItems, title, tags } = section
  const content = section?._rawContent
  const allowDrag = tags?.includes("allow-drag")
  const background = tags?.includes("background")
  const pair = tags?.includes("pair")
  return (
    <Container
      fullWidthOnMobile={false}
      constrainedToBreakPoint
      className={`${classNames(pair && "!px-0 py-4")} ${
        background && "bg-[#F9F9FA] py-[30px] px-[50px] rounded-[28px]"
      }`}
    >
      {title && (
        <Heading
          as={`${background ? "h4" : "h2"}`}
          className="text-blue-500 mb-2 lg:mb-6 text-center"
        >
          {title}
        </Heading>
      )}
      {content && (
        <Box
          className={classNames(
            "max-w-[420px] px-4 m-auto [&>p]:mt-4 [&>h4]:font-extrabold"
          )}
        >
          <PortableText value={content} components={serializers} />
        </Box>
      )}
      <Box
        className={classNames(pair && "max-w-[335px] lg:max-w-[505px] mx-auto")}
      >
        <SwiperSlider
          pagination={false}
          navigation={false}
          autoplay={{
            delay: 5000,
          }}
          speed={700}
          breakpoints={{
            1024: {
              autoplay: false,
              allowTouchMove: allowDrag ? true : false,
            },
          }}
          slidesPerView="auto"
          childClassName="max-w-[156px] ml-auto mr-3"
        >
          {listItems.map((item: any, idx: any) => (
            <Box className="w-full h-full" key={idx}>
              <GatsbyImage
                image={item?.Image?.asset?.gatsbyImageData}
                objectFit="contain"
                alt={item?.Image?.asset?.altText || "awards"}
              />
            </Box>
          ))}
        </SwiperSlider>
      </Box>
    </Container>
  )
}

export default SectionAwards
